module.exports = __webpack_public_path__ + "static/media/MEINCE_MENU-normal.4ec3acb0.png";